<template>
  <!--
      作者：kmdshop
      时间：2020-06-01
      描述：插件中心-预约服务-修改
    -->
    <el-dialog
    title="修改预约服务"
    :visible.sync="dialogVisible"
    @close="dialogFormVisible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    width="50%"
  >

  <div class="product-add pb50">

    <el-form size="small" :model="form" ref="form" :rules="rules" label-width="100px">


        <el-form-item label="预约服务名称" prop="name"><el-input v-model="form.name" placeholder="请输入预约服务名称" class="max-w460"></el-input></el-form-item>
     

        <!-- 选择管家 -->
     <!-- <el-form-item label="管家" :rules="[{required: true,message: ' '}]">
        <div class="d-s-s d-c">
          <el-button @click="openStaff" icon="el-icon-plus">选择管家</el-button>
          <ul class="d-s-s select-user">
            <li class="mr10 d-c-c d-c p-10-0"  :key="index">
              <img :src="staff.image_url" class="radius" width="30" height="30" />
              <p class="lh18 ww100 text-ellipsis">{{staff.name}}</p>
            </li>
          </ul>
        </div>
      </el-form-item>
         <Staff :storeId="Number(form.staff_id)" :is_open="isOpenStaff"
          :multi="false" @close="closeStaffFunc"></Staff> -->

    
      
      
        <el-form-item label="特约服务bannar：" prop="model.image">
					<div class="draggable-list">
						<draggable class="wrapper" v-model="form.bannar">
							<transition-group>
								<div v-for="(item, index) in form.bannar" :key="item.file_path">
									<div class="item">
										<img v-img-url="item.file_path" alt="file_path" />
										<a href="javascript:void(0);" class="delete-btn"
											@click.stop="deleteImg(index,'bannar')"><i class="el-icon-close"></i></a>
									</div>
								</div>
							</transition-group>
						</draggable>
						<div class="item img-select" @click="openProductUpload('bannar')">
							<i class="el-icon-plus"></i>
						</div>
					</div>
				</el-form-item>


				<el-form-item label="特约服务图片：" prop="model.image">
					<div class="draggable-list">
						<draggable class="wrapper" v-model="form.image">
							<transition-group>
								<div v-for="(item, index) in form.image" :key="item.file_path">
									<div class="item">
										<img v-img-url="item.file_path" alt="file_path" />
										<a href="javascript:void(0);" class="delete-btn"
											@click.stop="deleteImg(index,'album')"><i class="el-icon-close"></i></a>
									</div>
								</div>
							</transition-group>
						</draggable>
						<div class="item img-select" @click="openProductUpload('album')">
							<i class="el-icon-plus"></i>
						</div>
					</div>
				</el-form-item>

    <el-form-item label="预约服务介绍">
        <div class="edit_container">
          <Uediter v-model="form.intro" :text="ueditor.text" :config="ueditor.config" ref="ue"></Uediter>
        </div>
      </el-form-item>  

      <el-form-item label="排序" prop="sort"><el-input v-model="form.sort" placeholder="请输入排序" class="max-w460"></el-input></el-form-item>
       
    
      <!--提交-->
      <div class="common-button-wrapper">
        <el-button size="small" type="info" @click="cancelFunc">取消</el-button>
        <el-button size="small" type="primary" @click="onSubmit" :loading="loading">提交</el-button>
      </div>
    </el-form>
    <Upload v-if="isProductUpload" :config="{ total: 9 }" :isupload="isProductUpload" @returnImgs="returnProductImgsFunc">上传图片
    </Upload>
    <!-- <Categoryas :isproduct="iscategorya" :excludeIds="excludeIds" :islist="false" @closeDialog="closeDialogFunc"></Categoryas> -->
  </div>
</el-dialog>
  
</template>

<script>
import Service_sApi from '@/api/service_s.js';
import Upload from '@/components/file/Upload';
import Categoryas from "@/components/categorya/index.vue";
import draggable from "vuedraggable";
import Uediter from '@/components/UE.vue';
  // import Staff from '@/components/user/Staff.vue'
export default {
  components: {
     /*图片上传*/
     Upload: Upload,
     Categoryas,
     draggable,
     Uediter,
        // Staff
  },
  data() {
    return {
          /*是否上传图片*/
          isupload: false,
      isImg: false,  
          /*富文本配置*/
          ueditor: {
        text: '',
        config: {
          initialFrameWidth: 400,
          initialFrameHeight: 500
        }
      },
      /*form表单数据*/
      form: {
         nickname:'',
        phone:'',
        name: '',
        code: 'custom',
        // categorya:{
        //   name:""
        // },
       image:[],
        sort:50,
        intro:"",
       bannar:[],
              // staff_id:0,
      },
      loading: false,
      /*验证规则*/
      rules: {
        name: [{ required: true, message: '请输入预约服务名称', trigger: 'blur' }],
      },
      dialogVisible:false,
      iscategorya:false,
      excludeIds:[],
      isProductUpload:false,
         code:"album",
                 // 选择用户开关
        // isOpenStaff: false,
        // staff:{}
    };
  },
  created() {
    console.log(11111)
    this.dialogVisible = this.open_add;
    this.getDetail();
  },
  props: ["open_add","service_s_id"],
  methods: {
     /*打开获取用户*/
      // openStaff() {
      //   this.isOpenStaff = true
      // },
      // /*关闭获取用户*/
      // closeStaffFunc(e) {
      //   if (e.type != 'error') {
      //     this.form.staff_id = e.params.staff_id
      //      this.staff = e.params
      //   }
      //   this.isOpenStaff = false
      // },

    chooseCategory(){
      this.iscategorya = true;
    },
     /*上传*/
     openUpload(e) {
      this.isupload = true;
    },

     /*获取图片*/
     returnImgsFunc(e) {
      let self = this;
      if (e != null) {
        this.form.image_id = e[0].file_id;
          this.form.image = e[0].file_path;
          this.isImg = true;
        
      }
      this.isupload = false;
    },
     /*关闭弹窗*/
     dialogFormVisible(result) {
      this.$emit("close", {});
    },
    cancelFunc(){//取消
      this.dialogFormVisible("error")
    },
    getDetail() {
      let self = this;
      // 取到路由带过来的参数
      Service_sApi.detail({service_s_id: self.service_s_id},true).then(res => {
          self.form = res.data;
          self.ueditor.text = self.form.intro;
          // self.staff = res.data.staff?res.data.staff:{}
          self.isImg = true
          self.loading = false;
          if(!self.form.bannar){
            self.form.bannar = [];
          }
          if(!self.form.image){
            self.form.image = [];
          }
        })
        .catch(error => {});
    },
    onSubmit() {
      let self = this;
      let form = self.form;

      form.service_s_id = self.service_s_id;
      form.intro = this.$refs.ue.getUEContent();
      self.$refs.form.validate(valid => {
        if (valid) {
          self.loading = true;
          Service_sApi.edit(form, true)
            .then(data => {
              self.loading = false;
              self.$message({
                message: data.msg,
                type: 'success'
              });
              self.dialogFormVisible("error")
            })
            .catch(error => {
              self.loading = false;
            });
        }
      });
    },

    /*取消修改，返回任务列表*/
    cancelFunc() {
      this.$emit("close", { openDialog: false,"type":"" });
    },
    openProductUpload: function (code) {
      this.isProductUpload = true;
      this.code = code
    },

  
    returnProductImgsFunc(e) {
      if(this.code == 'album'){
        if (e != null) {
        let imgExpt = ["bmp", "jpg", "jpeg", "png", "gif"];
        let prevent = false;
        console.log(typeof imgExpt);
        e.forEach((element) => {
          let data_array = element.file_path.split(".");
          let ext = data_array[data_array.length - 1];
          imgExpt.forEach((e) => {
            if (e === ext) {
              prevent = true
              return false
            }
          });
        });

        if (!prevent) {
          this.$message.error("图片类型有误,请选择正确的图片格式");
          return false;
        }

        let imgs = this.form.image.concat(e);
        this.$set(this.form, "image", imgs);
      }
      }else{
        if (e != null) {
        let imgExpt = ["bmp", "jpg", "jpeg", "png", "gif"];
        let prevent = false;
        console.log(typeof imgExpt);
        e.forEach((element) => {
          let data_array = element.file_path.split(".");
          let ext = data_array[data_array.length - 1];
          imgExpt.forEach((e) => {
            if (e === ext) {
              prevent = true
              return false
            }
          });
        });

        if (!prevent) {
          this.$message.error("图片类型有误,请选择正确的图片格式");
          return false;
        }

        let imgs = this.form.bannar.concat(e);
        this.$set(this.form, "bannar", imgs);
      }
      }
      
      this.isProductUpload = false;
    },

    /*删除商品图片*/
    deleteImg(index,code) {
      if(code == 'album'){
        this.form.image.splice(index, 1);
      }else if(code == 'bannar'){
        this.form.bannar.splice(index, 1);
      }
      
    },
   
  }
};
</script>

<style>
.edit_container {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

.ql-editor {
  height: 400px;
}



.draggable-list {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: wrap;
}

.draggable-list .wrapper > span {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}

.draggable-list .item {
  position: relative;
  width: 110px;
  height: 110px;
  margin-top: 10px;
  margin-right: 10px;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #dddddd;
}

.draggable-list .delete-btn {
  position: absolute;
  top: 0;
  right: 0;
  width: 16px;
  height: 16px;
  background: red;
  line-height: 16px;
  font-size: 16px;
  color: #ffffff;
  display: none;
}

.draggable-list .item:hover .delete-btn {
  display: block;
}

.draggable-list .item img {
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  max-height: 100%;
  max-width: 100%;
}

.draggable-list .img-select {
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px dashed #dddddd;
  font-size: 30px;
}

.draggable-list .img-select i {
  color: #409eff;
}
</style>



// WEBPACK FOOTER //
// src/views/plus/service_s/index/part/edit.vue